import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[wzSetFocus]',
  standalone: false,
})
export class SetFocusDirective {
  constructor(private el: ElementRef) {}

  @Input()
  set wzSetFocus(focus: boolean) {
    if (focus) {
      this.el.nativeElement.focus();
    }
  }
}
